export default __webpack_public_path__ + "static/media/rock5.e88769fd.jpg";